import { createSlice } from '@reduxjs/toolkit';
import { IResourceSkill } from '../../../../dto';
import { setResourceSkills } from '../actions';
import { MN_RESOURCE_SKILLS, TYPE_LIST } from '../../../../common';

export interface ResourceSkillsState {
  data: IResourceSkill[];
  loading: boolean;
  error: string | null;
}

const initialState: ResourceSkillsState = {
  data: [],
  loading: false,
  error: null,
};

export const resourceSkillsSlice = createSlice({
  name: `${MN_RESOURCE_SKILLS}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setResourceSkills, (state, { payload }) => {
      state.data = payload;
    });
  },
});
